import React, { Component } from 'react'
import PropTypes from 'prop-types'
import GSAP from 'react-gsap-enhancer'
import animations from '../../utils/animations'

const withFadeInUpAnimation = (BaseComponent) => {
  class WithFadeInUpAnimationWrapper extends Component {
    static propTypes = {
      delay: PropTypes.number,
    }

    static defaultProps = {
      delay: 0,
    }

    componentDidMount() {
      this.addAnimation(animations.createEnterAnim, { delay: this.props.delay || 0 })
    }

    render() {
      return <BaseComponent {...this.props} />
    }
  }


  return GSAP()(WithFadeInUpAnimationWrapper)
}

export default withFadeInUpAnimation



// WEBPACK FOOTER //
// ./src/components/hocs/withFadeInUpAnimation.js